/** Backend integration scanners (Scanner header). Device scanners use localStorage until migrated. */

import { SCANNER_INTEGRATION_IDS } from "@/core/app/slices/integrations/scannerConstants"

export type ScannerIntegrationConfig = {
  /** Scanner id used in Redux `scannerSelect` and API lookups */
  key: string
  /** Value sent as `scannerName` / Scanner header to integration APIs */
  apiName: string
}

/** Display-only label for EasyRx in the scanner dropdown. */
export const EASY_RX_DISPLAY_NAME = "EasyRx"

const integrationIds = Object.values(SCANNER_INTEGRATION_IDS) as string[]

/** Whether the given type is a registered backend-driven integration scanner id. */
export const isIntegrationScanner = (type: string): boolean =>
  integrationIds.includes(type)

export const getIntegrationScannerConfig = (
  scannerName: string,
): ScannerIntegrationConfig | undefined =>
  integrationIds.includes(scannerName)
    ? { key: scannerName, apiName: scannerName }
    : undefined

export type ScannerListParams = {
  page: number
  type: string
  name: string
  location: string | null
}
